<app-search-and-archive-filter
  (searchChanged)="onSearchChanged($event)"
  [isRecordStateFilterEnabled]="false"
  [searchText]="searchText"
/>

@if (!filteredSettingGroups().length) {
  <app-empty-search-results></app-empty-search-results>
} @else {
  @for (settingGroup of filteredSettingGroups(); track $index) {
    <h3>{{ settingGroup.title }}</h3>
    <div class="settings-container flex-wrap">
      @for (setting of settingGroup.settings; track $index) {
        <app-settings-card
          (pressed)="onGoToRoute(setting.route)"
          [setting]="setting"
          [isShowDescription]="isShowDescription"
        />
      }
    </div>
  }
}
